import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import { ContributorViewResource, Permission, PermissionAction } from "generated/openApi";
import "moment-timezone";
import { isAuthorized } from "services";
import { ContributorTab } from "./ContributorPage";

export const ContributorTabs = (props: {
  viewResource: ContributorViewResource;
  setCurrentTab: (value: ContributorTab) => void;
}) => {
  const tabs: ContributorTab[] = initTabs();

  function initTabs(): ContributorTab[] {
    let tabs: ContributorTab[] = [];
    tabs.push("Contributor");
    if (isAuthorized(Permission.ContributorMatch, PermissionAction.View)) tabs.push("Time & Effort");
    if (isAuthorized(Permission.ContributorEmployment, PermissionAction.View)) tabs.push("Employments");
    return tabs;
  }

  const tabTotals: [ContributorTab, number | undefined][] = [
    ["Employments", props.viewResource.employmentsTotal],
    ["Time & Effort", props.viewResource.matchesTotal],
  ];

  return (
    <TabList
      onChange={(e, value) => props.setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => {
        const total: number | undefined = tabTotals.find((x) => x[0] === tab)?.[1];

        return (
          <Tab
            key={tab}
            label={
              <Stack direction="row" spacing="sm" alignItems="center">
                <Box>{tab}</Box>
                {total !== undefined && total !== null && <Chip label={total} size="small" />}
              </Stack>
            }
            value={tab}
          />
        );
      })}
    </TabList>
  );
};
